import axios from 'axios'
import qs from 'qs'

import * as _ from '../util/tool';
import * as types from '../vuex/types';

import context from '../main.js'

const loginUrl = '/sys/login';
const bindingLoginUrl = '/sso/ssoBindAccount';
// axios 配置
axios.defaults.timeout = 50000;
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';
// axios.defaults.baseURL = 'http://localhost:8080/';
// axios.defaults.baseURL = types.URL;
axios.defaults.baseURL = ''; //baseUrl记得要设置=""为空

// 添加一个请求拦截器
axios.interceptors.request.use((config) => {
	console.log(config);
	//判断是否是登录 
	if ((config.url.indexOf(loginUrl) > -1) || (config.url.indexOf(bindingLoginUrl) > -1)) {
		let time = String(new Date().getTime());
		config.headers.applogin = time;
	}else { //不是登录就要给headers添加token
		const token = sessionStorage.getItem('token');
		if (token) {
			// 在headers上面加参数
			config.headers.token = token;
		}
		else {
			console.log("无token");
			context.$router.replace("/login");
		}

	}

	if (config.method === 'post') {
		config.data = qs.stringify(config.data);
	}
	return config;
}, (error) => {
	_.toast("错误的传参", 'fail');
	return Promise.reject(error);
});

// 添加一个响应拦截器
axios.interceptors.response.use((res) => {
	if (!res.data.success) {
		// _.toast(res.data.msg);
		return Promise.reject(res);
	}
	return res;
}, (error) => {
	_.toast("网络异常", 'fail');
	return Promise.reject(error);
});

function get(url, params) {
	return new Promise((resolve, reject) => {
	  axios.get(types.addressUrl + url, {
	      params
	    }).then((res) => {
	    if (res.status == 200) {
	      resolve(res.data)
	    } else {
	      reject(res.data);
	    }
	  }).catch((error) => {
	    reject(error);
	  });
	})
}
function post(url, params) {
	return new Promise((resolve, reject) => {
	  axios.post(types.addressUrl + url, params).then((res) => {
	    if (res.status == 200) {
	      resolve(res.data)
	    } else {
	      reject(res.data);
	    }
	  }).catch((error) => {
	    reject(error);
	  });
	})
}
function form(url, params) {
	return new Promise((resolve, reject) => {
	  axios.post(types.addressUrl + url, qs.stringify(params), {
	    headers: {
	      'content-type': 'application/x-www-form-urlencoded'
	    },
	  }).then((res) => {
	    if (res.status == 200) {
	      resolve(res.data)
	    } else {
	      reject(res.data);
	    }
	  }).catch((error) => {
	    reject(error);
	  });
	})
}
function upLoadService(url, params) {
	return new Promise((resolve, reject) => {
		// const instance = axios.create({
		//   withCredentials: true
		// })

		axios.defaults.headers.post['Content-Type'] = 'multipart/form-data';
		axios.defaults.headers.post['token'] = sessionStorage.getItem('token');
		let formData = new FormData(); //创建form对象
		formData.append('file', params.file); //通过append向form对象添加数据
		// formData.append('fileSaveDir', 'changeRoom'); //通过append向form对象添加数据
		console.log(formData.get('file')); //FormData私有类对象，访问不到，可以通过get判断值是否传进去

		axios.post(types.addressUrl + url, formData, {
			headers: {
				// 'Access-Control-Allow-Credentials': true,
				// 'Access-Control-Allow-Origin': 'http://localhost:8100/',
				// 'Content-Type': 'multipart/form-data',
				// 'token': sessionStorage.getItem('token')
			} //这里是重点，需要和后台沟通好请求头，Content-Type不一定是这个值
		})
		.then(response => {
			console.log(response.data);
			if (res.status == 200) {
			  resolve(res.data)
			} else {
			  reject(res.data);
			}
		}).catch((error) => {
		  reject(error);
		});
	
	})
}

//获取url中参数
function getUrlParam(name) {
  var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
  var r = window.location.search.substr(1).match(reg);
  if (r != null) return decodeURI(r[2]);
  return null;
}
export default {
	get,
	post,
	form,
	getUrlParam,
	upLoadService,
	//登录
	doLogin(param) {
	  return this.post(loginUrl, param)
	},
	//绑定登录
	ssoBindAccount(params) {
	  return this.post(bindingLoginUrl, params)
	}
}






// WEBPACK FOOTER //
// ./src/fetch/api.js